export default __webpack_public_path__ + "static/media/sl.3d739d07.svg";